import React from 'react';

export const Row = ({k, children, id, className, onClick}) => {
    return <div key={k} {...{id: id || null}} className={`row-b ${className || ''}` } onClick={onClick}>{children}</div>
};